export const generateTableRowProperty = (data, selectedRow, updatedRow, deletedRow, disableTableClick) => {
    return {
        selected: selectedRow.includes(data),
        edited: updatedRow.includes(data),
        deleted: deletedRow.includes(data),
        disabled: disableTableClick,
    };
};
